<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="isMobile ? 12 : 4">
          <v-text-field
            :label="getCompanyLabels.transportations"
            v-model="name"
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 6 : 4"
          ><v-text-field label="Cost Per Km" v-model="unitCost"></v-text-field
        ></v-col>
        <v-col :cols="isMobile ? 6 : 4"
          ><v-text-field
            :label="getCompanyLabels.transportationFee"
            v-model="unitPrice"
          ></v-text-field
        ></v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <ForeignKeyField
            foreignColumn="category_id"
            :foreignTablesArray="['items_categories']"
            :foreignKeysArray="['category_id']"
            :foreignFieldValue="transportCategory"
            :branchID="null"
            @field-selected="setCategory"
          ></ForeignKeyField>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      ><v-row>
        <v-col cols="4"></v-col
        ><v-col cols="4">
          <v-btn dark rounded color="teal" large @click="createTransportation()"
            >Submit</v-btn
          ></v-col
        ><v-col cols="4"></v-col></v-row
    ></v-container>
  </div>
</template>

<script>
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";
import axios from "@/plugins/axios";

export default {
  components: { ForeignKeyField },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    name: null,
    unitCost: 0,
    unitPrice: 0,
    transportCategoryID: null,
    transportCategory: null,
  }),
  methods: {
    setCategory(vals) {
      this.transportCategoryID = vals[0];
      this.transportCategory = vals[1];
    },
    createTransportation() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-transportation",
          {
            name: this.name,
            unitCost: this.unitCost,
            unitPrice: this.unitPrice,
            categoryID: this.transportCategoryID,
          },
          this.getAccessToken
        )
        .then((transportation) => {
          if (transportation == "exist") {
            this.$emit("exist", "Transportation Exist");
          } else {
            this.$emit("transportation-created", transportation);
            this.$store.commit("setLoader", false);
          }
        });
    },
  },
};
</script>

<style></style>
